import { useState, useEffect } from 'react';

interface UseLoadingDotsOptions {
  baseText?: string;
  speed?: number;
}

export const useLoadingDots = ({ 
  baseText = 'Loading', 
  speed = 500 
}: UseLoadingDotsOptions = {}) => {
  const [displayText, setDisplayText] = useState(baseText);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    let dotCount = 0;
    let increasing = true;

    const animateDots = () => {
      if (increasing) {
        if (dotCount < 3) {
          dotCount++;
        } else {
          increasing = false;
          dotCount = 2; // Start going down from 2 dots
        }
      } else {
        if (dotCount > 0) {
          dotCount--;
        } else {
          increasing = true;
          dotCount = 1; // Start going up from 1 dot
        }
      }

      const dots = '.'.repeat(dotCount);
      setDisplayText(`${baseText}${dots}`);
      
      timeout = setTimeout(animateDots, speed);
    };

    // Start the animation
    timeout = setTimeout(animateDots, speed);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [baseText, speed]);

  return displayText;
};
